import { get as lodashGet } from "lodash-es";
import { useIsClientUserKind } from "../hooks/useIsClientUserKind";
import { useInstanceConfigQuery } from "@certa/queries/hooks/config.hook";

// Instance level config OS3_ENABLE_MASS_DELEGATION
export const useEnableOS3MassDelegation = (): boolean => {
  const { data: config } = useInstanceConfigQuery();
  const isOS3MassDelegationEnabled = lodashGet(
    config,
    "feature_toggles.OS3_ENABLE_MASS_DELEGATION",
    false
  );
  // Mass delegation is only available for client users
  const isClientUserKind = useIsClientUserKind();

  return isOS3MassDelegationEnabled && isClientUserKind;
};
